module.exports = {
      id: "icon-login-usage",
      viewBox: "0 0 10.66 10.66",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#icon-login",
      toString: function () {
        return this.url;
      }
    }